module.exports = __webpack_public_path__ + "img/backspace.e98c932f.svg";